import _ from 'lodash';
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles/index';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';


const styles = () => ({
	submitButton : {
		fontSize : 18,
		borderRadius : '100px',
		padding : '20px 30px',
		textTransform: 'uppercase'
	},
});

class FMPSubmitButton extends Component {
	render () {
		const {isDisabled } = this.props;
		return (
			<Fragment>
				{!isDisabled && this.renderActive()}
				{isDisabled && this.renderDisabled()}
			</Fragment>
		);
	}

	renderActive() {
		const { classes, onClick, buttonText} = this.props;
		return (
			<Button onClick={onClick} variant="contained" color="primary" className={classes.submitButton}>
				{buttonText}
			</Button>
		);
	}

	renderDisabled() {
		const { classes, buttonText, disabledText = 'Write access is disabled'} = this.props;
		return (
			<Tooltip
				title={disabledText}
				enterDelay={300}
			>
				<div style={{display:'inline-block'}}>
					<Button variant="contained" color="primary" className={classes.submitButton} disabled>
						{buttonText}
					</Button>
				</div>
			</Tooltip>
		);
	}
}

FMPSubmitButton.propTypes = {
	onClick : PropTypes.func.isRequired,
	buttonText : PropTypes.string.isRequired,
	classes: PropTypes.object.isRequired,
	isDisabled : PropTypes.bool,
	disabledText : PropTypes.string,
};

export default _.flow([
	withStyles(styles),
])(FMPSubmitButton);
